<template>
  <span
    role="checkbox"
    tabindex="0"
    :aria-checked="modelValue ? 'true' : 'false'"
    :aria-disabled="disabled ? 'true' : undefined"
    :class="{
      'bg-green': modelValue,
      'bg-grey-300': !modelValue,
      'opacity-40': disabled,
    }"
    class="relative inline-block shrink-0 h-6 border-2 border-transparent rounded-full border-solid box-border cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:shadow-outline"
    style="width: 44px;"
    @click="toggle"
    @keyup.space="toggle"
  >
    <span
      :class="{
        'translate-x-5': modelValue,
        'translate-x-0': !modelValue
      }"
      aria-hidden="true"
      class="inline-block h-5 w-5 rounded-full bg-white shadow transition ease-in-out duration-200"
    />
  </span>
</template>

<script>
export default {
  name: 'ToggleField',
  emits: ['update:modelValue'],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    modelValue: {
      value: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggle() {
      if (this.disabled) {
        return;
      }
      this.$emit('update:modelValue', !this.modelValue);
    },
  },
};
</script>
